export default __webpack_public_path__ + "static/media/provider-hero-image-v1.13c666b4.png";